module.exports = {
	'customFolder.m3.m310320': {
		'userSettings': 'Working Hours Settings',
		'scheduleGroupName': 'Shift group',
		'unpin': 'Unpin',
		'nailDown': 'Pin',
	},
	'customFolder.m3.m310320_grid': {
		'shiftType': 'Shift type',
		'thereAreClassesLeft': '<%=temp1%> shifts left',
		'shiftInformationLabel': 'Shift/Label',
		'joinTheWorkforce': 'Add Manpower',
		'editStaff': 'Edit Manpower',
		'duplicateWorkingHoursTimePeriod': 'Working hours overlap.',
		'time': 'hour',
		'breakTime': 'Rest time',
	},
};
